module.exports = __webpack_public_path__ + "static/media/logoMotherhood.669505fe.png";